const envSettings = window as any;

export const DOMAIN_URL = envSettings.DOMAIN_URL;
export const APP_API_URL = envSettings.APP_API_URL;
export const AUTHSVC_API_URL = envSettings.AUTHSVC_API_URL;
export const RECAPTCHA_SITEKEY = envSettings.RECAPTCHA_SITEKEY;
export const SERVER_URL = envSettings.SERVER_URL;
export const WEB_API_PATH = envSettings.WEB_API_PATH;
export const AUTH_SVC_PATH = envSettings.AUTH_SVC_PATH;
